import { Button, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { AuthForm } from 'hooks/useAuthForm';
import VerificationCodeInput from 'components/VerificationCodeInput';
import SubmitError from './SubmitError';

export default function ResetVerifyForm({ auth }: { auth: AuthForm }) {
  const { form, ui, loading, submitError, fieldErrors } = auth;

  return (
    <Stack
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        auth.handleConfirmReset();
      }}
      spacing={2}
    >
      <Typography variant="body1" fontWeight={500}>
        Новый пароль
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {auth.otpStrategy === 'phone'
          ? 'Введите код из SMS и придумайте новый пароль'
          : 'Введите код из письма и придумайте новый пароль'}
      </Typography>
      <VerificationCodeInput
        hideTitle
        error={fieldErrors.resetCode}
        onChange={(code) => {
          auth.updateForm({ resetCode: code });
          auth.setFieldError('resetCode', null);
          auth.setSubmitError(null);
        }}
      />
      <TextField
        fullWidth
        label="Новый пароль"
        type={ui.showNewPassword ? 'text' : 'password'}
        value={form.newPassword}
        onChange={(e) => {
          auth.updateForm({ newPassword: e.target.value });
          auth.setFieldError('newPassword', null);
        }}
        onBlur={() =>
          auth.setFieldError(
            'newPassword',
            form.newPassword ? auth.validatePassword(form.newPassword) : null
          )
        }
        error={!!fieldErrors.newPassword}
        helperText={fieldErrors.newPassword ?? 'Минимум 6 символов'}
        autoComplete="new-password"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                type="button"
                onClick={() => auth.updateUi({ showNewPassword: !ui.showNewPassword })}
                edge="end"
              >
                <Icon icon={ui.showNewPassword ? 'mdi:eye-off' : 'mdi:eye'} />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      <SubmitError error={submitError} />
      <Button
        fullWidth
        variant="contained"
        color="primary"
        size="large"
        type="submit"
        disabled={!form.resetCode || !form.newPassword || loading}
      >
        {loading ? 'Сохранение...' : 'Сохранить пароль'}
      </Button>
    </Stack>
  );
}
